import api from "@/api";
import { KeyValueModel, VersionModel } from "../types";

export default class VersionApi {
  static async single() {
    return await api.get("version");
  }

  static async create() {
    return await api.post("version");
  }

  static async update(data: KeyValueModel) {
    return await api.put("version", data);
  }
}
